export class SessionStorageService<T> {
  constructor(private key: string) {}

  get data(): T | undefined {
    const data = sessionStorage.getItem(this.key);

    if (!data) {
      return undefined;
    }

    const value = this.safeParseJson(data);

    return value;
  }

  save(data: T) {
    sessionStorage.setItem(this.key, JSON.stringify(data));
  }

  remove() {
    sessionStorage.removeItem(this.key);
  }

  private safeParseJson(rawData: string) {
    try {
      return JSON.parse(rawData) as T;
    } catch {
      this.remove();
      return undefined;
    }
  }
}
